import { useEffect, useState } from 'react';

/**
 * A displayable URL for something that may be a file the admin just picked or
 * an image URL the server already has.
 *
 * The object URL is revoked when the source changes or the component goes
 * away. Building one inline in a render or a memo leaks a blob per keystroke,
 * because every re-render of the wizard hands the preview a new URL and
 * nothing ever releases the old one.
 */
export const useObjectUrl = (source: File | Blob | string | null) => {
  const [url, setUrl] = useState<string | null>(
    typeof source === 'string' ? source : null
  );

  useEffect(() => {
    if (!source) {
      setUrl(null);
      return;
    }

    if (typeof source === 'string') {
      setUrl(source);
      return;
    }

    const objectUrl = URL.createObjectURL(source);
    setUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [source]);

  return url;
};
